.dimBox {
  width: 100%;
  background-color: var(--silver);
  padding: 2em;
  margin-bottom: 2em;
}

.dimensionTitle {
  margin-bottom: 1em;
}

.row {
  display: flex;
  min-height: 2em;
}

.label {
  flex-basis: 25%;
  text-align: right;
  padding-right: 2em;
  vertical-align: top;
}

.content {
  flex-basis: 75%;
}

.description,
.questionList,
.improvementSuggestions,
.feedback {
  margin-bottom: 1em;
}

.code {
  color: var(--gray);
  font-weight: 600;
  font-size: 0.9em;
}

.question {
  font-weight: 600;
}

.extraInfoLang {
  display: inline-block;
  font-weight: 400;
  line-height: 1;
  margin-bottom: 0.5em;
}

.borderlessButton {
  border: none;
  padding: 12px 15px;
  margin: 0 5px;
  color: var(--blue);
  background-color: transparent;
}
